
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b/faq-preview",
      function () {
        return require("private-next-pages/b/faq-preview.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/b/faq-preview"])
      });
    }
  